import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from './Header';
import { HelmetProvider } from 'react-helmet-async';
import Home from './components/Home';
import Rashifal from './components/Rashifal';
import LiveNews from './components/LiveNews';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import TajaKhabarDetails from './components/TajaKhabarDetails';
import CommonNewsDetailsPage from './components/CommonNewsDetailsPage';
import WebstorieDetails from './components/WebstorieDetails';
import VideoDetails from './components/VideoDetails';
import DaramDetails from './components/DaramDetails';
import KhelDetails from './components/KhelDetails';
import BuisnessDetails from './components/BuisnessDetails';
import RashiDetail from './components/RashiDetail';
import StateNewsCard from "./components/StateNewsDetails";
import Khels from './components/Khels';
import Bollywood from './components/Bollywood';
import VideoDetailsD from './components/VideoDetailsD';
import DaramDetailsD from './components/DaramDetailsD';
import WebStrorieD from './components/WebStrorieD';

import PuducherryDetails from './components/PuducherryDetails';
import NagalandDetails from './components/NagalandDetails';
import MizoramDetails from './components/MizoramDetails';
import MeghalayaDetails from './components/MeghalayaDetails';
import ManipurDetails from './components/ManipurDetails';
import AndamanNicobarDetails from './components/AndamanNicobarDetails';
import MadhyaPradeshDetails from './components/MadhyaPradeshDetails';
import ChhatisgarDetails from './components/ChhatisgarDetails';
import GujuratDetails from './components/GujuratDetails';
import GoaDetails from './components/GoaDetails';
import ChandigarhDetails from './components/ChandigarhDetails';
import JammuKashmirDetails from './components/JammuKashmirDetails';
import JharkhandDetails from './components/JharkhandDetails';
import TamilNaduDetails from './components/TamilNaduDetails';
import TripuraDetails from './components/TripuraDetails';
import DamanDivDetails from './components/DamanDivDetails';
import DadraNagarHaveliDetails from './components/DadraNagarHaveliDetails';
import DelhiDetails from './components/DelhiDetails';
import PunjabDetails from './components/PunjabDetails';
import BengalDetails from './components/BengalDetails';
import BiharDetails from './components/BiharDetails';
import MaharashtraDetails from './components/MaharashtraDetails';
import RajasthanDetails from './components/RajasthanDetails';
import LakshadweepDetails from './components/LakshadweepDetails';
import SikkimDetails from './components/SikkimDetails';
import HaryanaDetails from './components/HaryanaDetails';
import HimachalPradeshDetails from './components/HimachalPradeshDetails';
import ArunachalPradeshDetails from './components/ArunachalPradeshDetails';
import AssamDetails from './components/AssamDetails';
import AndhraPradeshDetails from './components/AndhraPradeshDetails';
import UttarPradeshDetails from './components/UttarPradeshDetails';
import UttarakhandDetails from './components/UttarakhandDetails';
import OdishaDetails from './components/OdishaDetails';
import KarnatakaDetails from './components/KarnatakaDetails';
import KeralaDetails from './components/KeralaDetails';


import Epaper from './components/Epaper';
import EpaperDetails from './components/EpaperDetails';
import NotFound from './components/NotFound';
import World from './components/World';
import TechnologyDetails from './components/TechnologyDetails';
import PoliticsPage from './components/PoliticsPage';
import NationalPage from './components/NationalPage';
import LifeStyle from './components/LifeStyle';
import OpinionPage from './components/OpinionPage';
import OpinionDetails from './components/OpinionDetails';
import OpinionWithIdPage from './components/OpinionWithIdPage';
import Viewer from './components/viewer';
import JanSampark from './components/JanSamparkRSS';
import CookieConsentBanner from './components/CookieConsentBanner';
import PrivacyPolicy from './components/PrivacyPolicy';
import Contact from './components/Contact';

function App() {
  const location = useLocation();

  // const shouldRenderHeaderFooter = (path) => {
  //   // const excludedPaths = ['/WebStrorieD', '/Epaper', '/pdf'];
  //   return !excludedPaths.some(excludedPath => path.startsWith(excludedPath));
  // };

  return (
    <>
      {/* {shouldRenderHeaderFooter(location.pathname) && <Header />} */}
      {<Header />}
      {/* <ScrollTo /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/News-Details/:mainKhabarId" element={<CommonNewsDetailsPage />} />

        <Route path="/Live-News" element={<LiveNews />} />
        <Route path="/TajaKhabar-News" element={<TajaKhabarDetails />} />
        <Route path="/Khel-News" element={<Khels />} />
        <Route path="/KhelDetails" element={<KhelDetails />} />
        <Route path="/Technology-News" element={<TechnologyDetails />} />
        <Route path="/Buisness-News" element={<BuisnessDetails />} />
        <Route path="/World-News" element={<World />} />
        <Route path="/Politics-News" element={<PoliticsPage />} />
        <Route path="/Bollywood-News" element={<Bollywood />} />
        <Route path="/Daram-News" element={<DaramDetails />} />
        <Route path="/Daram-News/:mainKhabarId" element={<DaramDetailsD />} />
        <Route path="/National-News" element={<NationalPage />} />


        <Route path="/MadhyaPradesh-News" element={<MadhyaPradeshDetails />} />
        <Route path="/Chhattisgarh-News" element={<ChhatisgarDetails />} />

        <Route path="/andaman-and-nicobar-islands-news" element={<AndamanNicobarDetails />} />
        <Route path="/andhra-pradesh-news" element={<AndhraPradeshDetails />} />
        <Route path="/arunachal-pradesh-news" element={<ArunachalPradeshDetails />} />
        <Route path="/assam-news" element={<AssamDetails />} />
        <Route path="/bihar-news" element={<BiharDetails />} />
        <Route path="/chandigarh-news" element={<ChandigarhDetails />} />
        <Route path="/dadra-and-nagar-haveli-news" element={<DadraNagarHaveliDetails />} />
        <Route path="/daman-and-diu-news" element={<DamanDivDetails />} />
        <Route path="/delhi-news" element={<DelhiDetails />} />
        <Route path="/goa-news" element={<GoaDetails />} />
        <Route path="/gujarat-news" element={<GujuratDetails />} />
        <Route path="/haryana-news" element={<HaryanaDetails />} />
        <Route path="/himachal-pradesh-news" element={<HimachalPradeshDetails />} />
        <Route path="/jammu-and-kashmir-news" element={<JammuKashmirDetails />} />
        <Route path="/jharkhand-news" element={<JharkhandDetails />} />
        <Route path="/karnataka-news" element={<KarnatakaDetails />} />
        <Route path="/kerala-news" element={<KeralaDetails />} />
        <Route path="/lakshadweep-news" element={<LakshadweepDetails />} />
        <Route path="/maharashtra-news" element={<MaharashtraDetails />} />
        <Route path="/manipur-news" element={<ManipurDetails />} />
        <Route path="/meghalaya-news" element={<MeghalayaDetails />} />
        <Route path="/mizoram-news" element={<MizoramDetails />} />
        <Route path="/nagaland-news" element={<NagalandDetails />} />
        <Route path="/odisha-news" element={<OdishaDetails />} />
        <Route path="/puducherry-news" element={<PuducherryDetails />} />
        <Route path="/punjab-news" element={<PunjabDetails />} />
        <Route path="/rajasthan-news" element={<RajasthanDetails />} />
        <Route path="/sikkim-news" element={<SikkimDetails />} />
        <Route path="/tamil-nadu-news" element={<TamilNaduDetails />} />
        <Route path="/tripura-news" element={<TripuraDetails />} />
        <Route path="/uttarakhand-news" element={<UttarakhandDetails />} />
        <Route path="/uttar-pradesh-news" element={<UttarPradeshDetails />} />
        <Route path="/west-bengal-news" element={<BengalDetails />} />


        <Route path="/LifeStyle-News" element={<LifeStyle />} />
        <Route path="/Rashifal-News" element={<Rashifal />} />
        <Route path="/Rashifal-" element={<Rashifal />} />
        <Route path="/Rashifal-News/:mainKhabarId" element={<RashiDetail />} />
        <Route path="/jansampark" element={<JanSampark />} />
        <Route path="/Opinions" element={<OpinionPage />} />
        <Route path="/OpinionDetails/:id" element={<OpinionDetails />} />
        <Route path="/OpinionAccordingTomember/:id" element={<OpinionWithIdPage />} />
        <Route path="/Video-News" element={<VideoDetails />} />
        <Route path="/Video-News/:shortVideoId" element={<VideoDetailsD />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/contactUs" element={<Contact />} />
        <Route path="/OtherState-News/:slug" element={<StateNewsCard />} />
        <Route path="/Webstorie-News" element={<WebstorieDetails />} />
        <Route path="/WebStrorie-News/:webStoriesId" element={<WebStrorieD />} />
        <Route path="/Epaper-News" element={<Epaper />} />
        <Route path="/Epaper-News/:epaperId" element={<EpaperDetails />} />
        <Route path="/pdf/:id" element={<Viewer />} />
        <Route path="*" element={<NotFound />} />

        {/* <Route path="/Card" element={<Card />} /> */}
        {/* <Route path="/TajaKhabr" element={<TajaKhabr />} /> */}
        {/* <Route path="/MpNews" element={<MpNews />} /> */}
        {/* <Route path="/Sports" element={<Sports />} /> */}
        {/* <Route path="/Slider-News/:mainKhabarId" element={<SliderDetails />} /> */}
        {/* <Route path="/TajaKhabar-News/:mainKhabarId" element={<TajaKhabarDetailsNews />} /> */}
        {/* <Route path="/MadhyaPradesh-News/:mainKhabarId" element={<MadhyapradeshDetailsD />} /> */}
        {/* <Route path="/Chhattisgarh-News/:mainKhabarId" element={<ChhatisgarDetailsD />} /> */}
        {/* <Route path="/Business-News/:mainKhabarId" element={<BusinessDetailsD />} /> */}
        {/* <Route path="/Khel-News/:mainKhabarId" element={<KhelDetailsD />} /> */}
        {/* <Route path="/Bollywood-News/:mainKhabarId" element={<BollywoodDetails />} /> */}
        {/* <Route path="/International-News" element={<International />} /> */}
        {/* <Route path="/International-News/:mainKhabarId" element={<InternationalDetails />} /> */}
        {/* <Route path="/OtherState-News/:stateId" element={<OtherState />} />
        <Route path="/OtherState-News" element={<OtherStateNewsCard />} /> */}
        {/* <Route path="/Other-State-News/:mainKhabarId" element={<OtherStateDetails />} /> */}
        {/* <Route path="/DemoD" element={<DemoD />} /> */}
        {/* <Route path="/World-News/:mainKhabarId" element={<WorldD />} /> */}
        {/* <Route path="/Technology-News/:mainKhabarId" element={<TechnonlogyD />} /> */}
        {/* <Route path="/Politics-News/:mainKhabarId" element={<PoliticsD />} /> */}
        {/* <Route path="/National-News/:mainKhabarId" element={<NationalD />} /> */}
        {/* <Route path="/Opinions_Details/:mainKhabarId" element={<OpinionDetails />} /> */}
      </Routes>
      {<Footer />}
      {/* {shouldRenderHeaderFooter(location.pathname) && <Footer />} */}
      <ScrollToTop />
    </>
  );
}

function AppWrapper() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <App />
        <CookieConsentBanner />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default AppWrapper;
